import { oneCapitalValidator, oneLowercaseValidator, oneNumberValidator, minLengthValidator, passwordsMatchValidator } from './password-validators';
export var PasswordCriterias = [{
  key: '1capital',
  validationFunc: oneCapitalValidator,
  displayText: '1 capital letter'
}, {
  key: '1lowercase',
  validationFunc: oneLowercaseValidator,
  displayText: '1 lowercase letter'
}, {
  key: '1number',
  validationFunc: oneNumberValidator,
  displayText: '1 number'
}, {
  key: 'minLength',
  validationFunc: minLengthValidator,
  displayText: '6 character minimum'
}, {
  key: 'passwordsMatch',
  validationFunc: passwordsMatchValidator,
  displayText: 'Both passwords match',
  isForConfirm: true
}];